// react-magnetic-di - temporary comment, for auto dependency injection in tests
import { useCallback, useMemo } from 'react';
import { ON_INIT_CHANGE_ID } from '../../../../../../common/constants/constants';
import { useOnBridgeError } from './use-on-bridge-error';
import { useOnChangeSubscription } from './use-on-change-subscription';
import { useOnErrorSubscription } from './use-on-error-subscription';
import { useOnInit } from './use-on-init';
import { useRegisterFields } from './use-register-fields';
import { useSubmit } from './use-submit';
export var useCustomBridgeMethods = function useCustomBridgeMethods(_ref) {
  var onBridgeCommunicationReceived = _ref.onBridgeCommunicationReceived,
    uiModifications = _ref.uiModifications,
    _ref$moduleScopes = _ref.moduleScopes,
    moduleScopes = _ref$moduleScopes === void 0 ? [] : _ref$moduleScopes,
    appId = _ref.appId;
  var _useOnInit = useOnInit({
      moduleScopes: moduleScopes
    }),
    onInitPromise = _useOnInit.onInitPromise;
  var subscribeToChanges = useOnChangeSubscription({
    uiModifications: uiModifications,
    moduleScopes: moduleScopes
  });
  var submit = useSubmit({
    moduleScopes: moduleScopes,
    appId: appId
  });
  var registerFields = useRegisterFields({
    appId: appId
  });
  var onBridgeError = useOnBridgeError({
    appId: appId
  });
  var subscribeToErrors = useOnErrorSubscription({
    appId: appId
  });
  var getInternalAPI = useCallback(function () {
    onBridgeCommunicationReceived === null || onBridgeCommunicationReceived === void 0 || onBridgeCommunicationReceived();
    return {
      data: {
        onInitChangeId: ON_INIT_CHANGE_ID,
        uiModifications: uiModifications,
        featureFlags: {
          // keep as true, we will also need to do the forge-bridge clean-up
          // and wait for some period of time so the users will migrate to the version without this FG.
          'forge-ui-modifications-screentabs_qoa33': true
        }
      },
      actions: {
        getOnInitData: function getOnInitData() {
          return onInitPromise;
        },
        subscribeToChanges: subscribeToChanges,
        submit: submit,
        registerFields: registerFields,
        onBridgeError: onBridgeError,
        subscribeToErrors: subscribeToErrors
      }
    };
  }, [onBridgeCommunicationReceived, uiModifications, subscribeToChanges, submit, registerFields, onInitPromise, onBridgeError, subscribeToErrors]);
  var customBridgeMethods = useMemo(function () {
    return {
      getUiModificationsInternalAPI: getInternalAPI
    };
  },
  // TODO: Make sure that the `getInternalAPI` is not being regenerated on the consecutive renders
  // because the bridge consumes only the first version of it, if so clear the array deps to be [].
  [getInternalAPI]);
  return {
    customBridgeMethods: customBridgeMethods
  };
};